import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Formik, Form, FormikHelpers } from 'formik';
import { useSelector } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';
import { Button, Alert } from '@whitelabel/component-library';
import commonMessages from '@whitelabel/helpers/messages/commonMsg';
import { ReactComponent as CrossIcon } from '@whitelabel/media/icons/small/cross.svg';
import { StyledContactFormInModal, StyledDivider } from '@whitelabel/xcover-shared/styled/StyledContactForm';
import contactFormMsg from '@whitelabel/xcover-shared/helpers/messages/contactFormMsg';
import { IContactFormValues } from '@whitelabel/xcover-shared/helpers/types';
import { getContactFormSchema } from '../../../helpers/forms/schema';
import xcoverCommonMessages from '../../../helpers/messages/commonMsg';
import { RootState } from '../../../store';
import { createSupportTicket, useGetInitialValues } from './helpers';
import ContactFormBaseFields from './ContactFormBaseFields';

export interface IContactFormInModalProps {
  className?: string;
  onSubmit?: (values: IContactFormValues) => void;
  onSubmitSuccess: () => void;
  onCancelButtonClick?: () => void;
  bookingID?: string;
}

const ContactFormInModal = ({
  className,
  onSubmit,
  onSubmitSuccess,
  onCancelButtonClick,
  bookingID,
}: IContactFormInModalProps): JSX.Element => {
  const intl = useIntl();
  const user = useSelector(({ user: { data } }: RootState) => data);
  const validationSchema = getContactFormSchema(intl.formatMessage, !!user);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);
  const handleSubmit = (values: IContactFormValues, formikHelpers: FormikHelpers<IContactFormValues>) => {
    createSupportTicket(intl, !!user, true)(values, formikHelpers);
    if (onSubmit) {
      onSubmit(values);
    }
  };

  return (
    <StyledContactFormInModal className={className}>
      <p>{ReactHtmlParser(intl.formatMessage(contactFormMsg.leadText))}</p>
      <Formik
        initialValues={useGetInitialValues(true, bookingID)}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting, status, setFieldValue }) => (
          <>
            {status === 'success' && onSubmitSuccess()}
            {status === 'api_error' && <Alert color="danger">{intl.formatMessage(xcoverCommonMessages.error)}</Alert>}
            <Form>
              <ContactFormBaseFields
                setIsSubmitDisabled={setIsSubmitDisabled}
                isSubmitting={isSubmitting}
                setFieldValue={setFieldValue}
              />
              <StyledDivider />
              <Button type="submit" loading={isSubmitting} disabled={isSubmitDisabled}>
                {intl.formatMessage(contactFormMsg.submitButtonText)}
              </Button>
              <Button type="button" buttonType="secondary" icon={CrossIcon} onClick={onCancelButtonClick}>
                {intl.formatMessage(commonMessages.cancelButtonText)}
              </Button>
            </Form>
          </>
        )}
      </Formik>
    </StyledContactFormInModal>
  );
};

export default ContactFormInModal;
